import { React, useEffect, useState } from "react";
import MyPdf from "../../page/registration/myPdf";
import { useMutation } from "@apollo/react-hooks";
import { ON_DOWNLOAD } from "../../apollo/registrationstudent/index";
import consts from "../../consts";
import { formatDatePDF } from "../../common/super";

const PdfPage = (data) => {
  console.log("data===>>>>>>", data);
  const [onDownload] = useMutation(ON_DOWNLOAD);
  const pdf = new MyPdf();
  const [pdfData, setPdfData] = useState(null);

  var examCenter = {
    SKU: "ມຂ",
    KHAMMOUAN: "ມໍປາຍທ່າແຂກ",
    XEPON: "ມສ ເຊໂປນ",
  };

  async function generatePdf(isMounted) {
    const tableNumber = data?.data[0]?.student?.entranceCode;
    const gender = data?.data[0]?.student?.gender;
    let prefix = "";
    if (gender === "MALE") {
      prefix = "ທ້າວ";
    } else if (gender === "MONK") {
      prefix = "ຄູບາ";
    } else if (gender === "NOVICE") {
      prefix = "ສໍາມະເນນ";
    } else {
      prefix = "ນາງ";
    }
    const roomName = data?.data[0]?.student?.classroom.name ?? "";
    const group = data?.data[0]?.student?.classroom.group ?? "";
    const firstName = data?.data[0]?.student?.firstNameL ?? "";
    const lastName = data?.data[0]?.student?.lastNameL ?? "";
    const occupation = data?.data[0].student?.personalTypeWorkplace ?? "";
    const dateOfBirth = formatDatePDF(data?.data[0]?.student?.birthday) ?? "";
    const bornVillage = data?.data[0]?.student?.birthAddress?.village ?? "";
    const bornDistrict = data?.data[0]?.student?.birthAddress?.district ?? "";
    const bornProvince = data?.data[0]?.student?.birthAddress?.province ?? "";
    const school = data?.data[0]?.comingFrom?.graduatedSchool ?? "";
    const graduateDistrict = data?.data[0]?.comingFrom?.graduatedDistrict ?? "";
    const graduateProvince = data?.data[0]?.comingFrom?.graduatedProvince ?? "";
    const centerOfExam = "26 ສິງຫາ 2026";
    const approvedAt = data?.data[0]?.approvedAt ?? "";
    const result = await onDownload({
      variables: {
        data: {
          url: `${consts.S3_IMAGE + data?.data[0]?.student?.image}`,
        },
      },
    });
    // console.log("image===", result.data?.onDownload?.data);
    // console.log("school===", school);
    const profileBase64 = result.data?.onDownload?.data;
    const blod = await pdf.generatePdf(
      tableNumber,
      roomName,
      profileBase64,
      prefix,
      firstName,
      lastName,
      // occupation,
      dateOfBirth,
      bornVillage,
      bornDistrict,
      bornProvince,
      // school,
      group,
      centerOfExam,
      approvedAt,
    );
    console.log("blod ", blod);
    const base64 = await pdf.convertPDFToImage(blod);
    console.log("base64 == ", base64);
    setPdfData(base64);
  }

  useEffect(() => {
    console.log(data);
    if (data?.data[0]?.student?.entranceCode) {
      let isMounted = true;
      generatePdf(isMounted);
    } else if (data?.data) {
      setPdfData(data?.data);
    }
  }, []);

  return (
    <div style={{ textAlign: "center", background: "black" }}>
      {pdfData ? (
        <img
          src={pdfData}
          alt="Converted Image"
          style={{ width: "100%", maxWidth: "550px" }}
        />
      ) : (
        <p style={{ color: "white" }}>ກຳລັງໂຫຼດ...</p>
      )}
    </div>
  );
};

export default PdfPage;
